import {createSelector} from 'reselect'

import {
  getState,
  setForm,
  updateForm,
  removeForm,
  formsSelector,
  onlyIfForm,
  useSelector,
} from '../../../store.js'
import ConfirmModal from '../../../common/components/Modal/ConfirmModal.js'
import apiverson, {formatV3APIURL} from '../../../common/apiverson.js'
import {showMessageToast} from '../../Header/Toast/index.js'
import {
  orderLinkSelector,
  billingEmailSelector,
  setOrderComments,
} from '../../../data/orders.js'
import ButtonPrimary from '../../../common/components/Button/ButtonPrimary.js'
import openNewTab from '../../../common/openNewTab.js'

export const MODAL_FORM = 'send_invoice_modal_form'

export function showSendInvoiceModal(orderNumber) {
  setForm(MODAL_FORM, {
    orderNumber,
    isSending: false,
    serverError: null,
  })
}

export function updateModalForm(updates) {
  updateForm(MODAL_FORM, updates)
}

export function closeModal() {
  removeForm(MODAL_FORM)
}

export const modalFormSelector = createSelector(
  formsSelector,
  (forms) => forms[MODAL_FORM],
)

export async function sendInvoice() {
  try {
    const {orderNumber} = modalFormSelector(getState())
    const link = orderLinkSelector(getState(), {orderNumber})

    updateModalForm({isSending: true, serverError: null})

    const {json} = await apiverson.post(`${link}/send_invoice`)

    setOrderComments(orderNumber, json.comments)

    showMessageToast('The invoice was successfully sent!')

    closeModal()
  } catch (err) {
    updateModalForm({
      serverError: `Error sending invoice: ${err.message || err.error_message}`,
      isSending: false,
    })
  }
}

function previewInvoice() {
  const {orderNumber} = modalFormSelector(getState())

  const link = orderLinkSelector(getState(), {orderNumber})

  openNewTab(formatV3APIURL(`${link}/send_invoice`))
}

function SendInvoiceModal({form}) {
  const email = useSelector((state) =>
    billingEmailSelector(state, {orderNumber: form.orderNumber}),
  )

  return (
    <ConfirmModal
      title="Send Invoice"
      confirmText="Send"
      cancelText={email ? 'Cancel' : 'Close'}
      onConfirm={email ? () => sendInvoice() : null}
      onCancel={() => closeModal()}
      MiddleButtons={
        email
          ? () => (
              <ButtonPrimary
                className="margin-right-10"
                alt
                onClick={previewInvoice}
              >
                Preview
              </ButtonPrimary>
            )
          : null
      }
      isSaving={form.isSending}
      isDisabled={!email}
      error={form.serverError}
    >
      {email ? (
        <p className="fs-01 margin-bottom-0">
          An invoice for this order will be emailed to <strong>{email}</strong>.
        </p>
      ) : (
        <p className="fs-01 margin-bottom-0">
          This order does not contain a valid billing email address.
        </p>
      )}
    </ConfirmModal>
  )
}

export default onlyIfForm(SendInvoiceModal, modalFormSelector)
